import type React from 'react';
import { useEffect } from 'react';

type SplashPhase = 'visible' | 'fading' | 'hidden';

interface SplashScreenProps {
  phase: SplashPhase;
  loading: boolean;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({
  phase,
  loading,
}) => {
  useEffect(() => {
    if (phase === 'hidden') return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [phase]);

  if (phase === 'hidden') return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white ${
        phase === 'fading'
          ? 'pointer-events-none animate-[splash-fade-out_600ms_ease-in-out_forwards]'
          : ''
      }`}
    >
      {loading ? (
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-slate-400" />
      ) : (
        <div className="flex animate-[logo-slide_700ms_ease-in-out_800ms_both] items-center gap-3">
          <img
            src="/icons/icononly.png"
            alt="Matchlytics"
            className="h-8 animate-[icon-appear_600ms_ease-out_forwards]"
          />
          <img
            src="/icons/matchlytics_name.png"
            alt="Matchlytics"
            className="h-6 animate-[name-reveal_700ms_ease-in-out_800ms_both]"
          />
        </div>
      )}
    </div>
  );
};
